/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { Color } from "src/libs/interfaces/layouts";
import addCSSClass from "src/libs/layout-app/utils/addCSSClass";
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass";
import { getContrastColor, getCssDemention } from "src/libs/utilities";
import { ILandingContent, ILandingSection } from "src/modules/pe-landing-module/data/interfaces";
import { components } from "src/modules/pe-landing-module/data/utils/components";
import { useComposition } from "src/modules/pe-landing-module/hooks/useComposition";
import usePosition from "src/modules/pe-landing-module/hooks/usePosition";
import { HTML } from "../../contentType";
import DataDummy from "../../landing-edit/DataDummy"; 
import { DataContentAnimateContainer } from "./DataContentAnimateContainer";
import { DataContentPositionContainer } from "./DataContentPositionContainer";

/* Protopia Ecosystem component */
export interface IHAccordeonSectionProps {
    data: ILandingContent
    section: ILandingSection
    isOpen: boolean;
    setOpen: () => void
    i: number
    color?: Color
    isOrder: boolean
}
const HAccordeonSection = ({data, section, isOpen, i, color, ...props}: IHAccordeonSectionProps): JSX.Element => {
    const composition = useComposition(section)
    const position = usePosition(section).position

    useEffect(() => {        
        addCSSClass(
        `landing-card-${data.id}`,
        `.landing-card-${data.id} {
                min-height:${getCssDemention(position.height)};
                z-index: ${ i }; 
                .haccordeon-card-cover-container {
                    ${
                        color 
                            ? 
                            `background-color: ${ color };
                            color: ${ getContrastColor( color ) };` 
                            : 
                            ``
                        } 
                    user-select: none;
                } 
            }`
        );

        return () => {
            removeCSSClass(`landing-card-${data.id}`);
        };
    }, [composition])
    const onOpen = (kind: "hover" | "click")=> { 
        if((section.interaction_kind || "click" ) === kind) {
            props.setOpen()
        } 
    }
    if(data.isHidden) {
        return <DataDummy key={ data.id } data={data} section={section} />
    }
    const type = data.type
    const DataComponent = type && components()[ type ]
        ?
        components()[ type ].c
        :
        HTML  

    return <div
            className={`landing-haccordeon-card-container landing-card-${data.id} ${
                isOpen ? "open" : ""
            }`}
        >
            <div className="haccordeon-card-cover-container">
                <div 
                    className="haccordeon-card-cover" 
                    onClick={() => onOpen("click")} 
                    onMouseEnter={ () => onOpen("hover") }
                >
                    <div className="haccordeon-card-title-container ">
                        <div className="haccordeon-card-title">
                            { props.isOrder ? i + 1 : (data.title || data.defaultTitle || i) }
                        </div>
                        <div className="haccordeon-card-description">
                            { data.i }
                        </div>
                    </div>
                    <div className="haccordeon-card-icon">
                        <i className={data.cardIcon?.toString()} />
                    </div>
                </div>
            </div>
            <div className="haccordeon-card-content-container ">
                 <DataContentAnimateContainer {...props} i={ i } section={section} data={[data]} >
                    <DataContentPositionContainer { ...props } i={ i } section={section} data={[data]} >
                        <DataComponent 
                            section={ section } 
                            data={ { ...data, type } } 
                        /> 
                    </DataContentPositionContainer>
                </DataContentAnimateContainer> 
            </div>
        </div>
}
export default HAccordeonSection